export default "__VITE_ASSET__l37B8Ffu__"